export default "__VITE_ASSET__I3AKQtNa__"